import axios from "axios";

let config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const setAuthorizationToken = (axios) => {
  let token = localStorage.getItem("sessionToken");
  if (token) {
    axios.defaults.headers.common["x-auth-token"] = `${token}`;
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
  }
};

class ApiClient {
  static get(url, params = null, token = null) {
    if (token) {
      setAuthorizationToken(axios, token);
    }
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .get(url, config)
        .then(function (response) {
          fulfill(response);
        })
        .catch(function (error) {
          if (error && error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  }
  static post(url, params, token = null) {
    if (token) {
      setAuthorizationToken(axios, token);
    }
    let conf = { ...config };
    if (params.temp_token) {
      conf.headers["x-temp-token"] = params.temp_token;
      delete params.temp_token;
    }
    return new Promise(function (fulfill, reject) {
      axios
        .post(url, JSON.stringify(params), conf)
        .then(function (response) {
          //debugger;
          fulfill(response);
        })
        .catch(function (error) {
          //debugger;
          if (error && error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  }

  static put(url, params, token = null) {
    if (token) {
      setAuthorizationToken(axios, token);
    }
    return new Promise(function (fulfill, reject) {
      axios
        .put(url, JSON.stringify(params), config)
        .then(function (response) {
          fulfill(response);
        })
        .catch(function (error) {
          if (error && error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  }

  static delete(url, token = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .delete(url, config)
        .then(function (response) {
          fulfill(response);
        })
        .catch(function (error) {
          if (error && error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  }
}

export default ApiClient;
